import { jsx as _jsx } from "react/jsx-runtime";
import { UserContextProvider } from './UserContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Router } from './Router';
import './KbLabFront.scss';
import { K5A } from '../utils';
export var ColorTheme;
(function (ColorTheme) {
    ColorTheme["lightBlue"] = "light-blue-theme";
    ColorTheme["darkBlue"] = "dark-blue-theme";
    ColorTheme["white"] = "white-theme";
})(ColorTheme || (ColorTheme = {}));
;
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 2,
            cacheTime: document.location.hostname.endsWith('labdevs.com') ? 0 : 300000,
            staleTime: document.location.hostname.endsWith('labdevs.com') ? 0 : 300000
        }
    }
});
export const KbLabFront = ({ config }) => {
    const pathFrags = window.location.hash.split('?');
    K5A.pageview(pathFrags[0]);
    if (!/noscroll[=]?/.test(pathFrags[1])) {
        window.scrollTo(0, 0);
    }
    return (_jsx(UserContextProvider, { children: _jsx(QueryClientProvider, { client: queryClient, children: Router(config, {}) }) }));
};
